import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from './FieldCustomerIdNumber.module.scss';
import {formatToIntegerValue} from "../../../../common/utils";

const FieldCustomerIdNumber = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-customerIdNumber',
    defaultMessage: `Customer's id number`
  });
  const defaultPlaceholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'customerIdNumber'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={
        <div className={styles.labelContainer}>
          <span>{labelText}</span>
        </div>
      }
      onChange={e => {
        field.onChange(field.name)(formatToIntegerValue(e));
      }}
      placeholder={defaultPlaceholder}
      defaultValue={field.value}
    />
  );
};

export default FieldCustomerIdNumber;
